import {CAN_GENERATE} from "./types";

export function canGenerate(payload) {
    return {
        type: CAN_GENERATE,
        payload: payload
    };
}
